import React, { useMemo } from 'react';
import Icon, { IconType } from '../../icons/Icon';

export enum BannerType {
  info = 'info',
  warning = 'warning',
}

interface BannerProps {
  type?: BannerType;
  title: string;
  children: React.ReactNode;
  iconType?: IconType;
  button?: boolean;
  width?: 'w-[800px]' | 'w-full';
}

const styles: Record<BannerType, string> = {
  info: 'bg-blue-100',
  warning: 'bg-warning-100',
} as const;

const defaultIcons: Record<BannerType, IconType> = {
  info: IconType.diamond1,
  warning: IconType.annotationAlert,
};

export default function Banner({
  type = BannerType.info,
  title,
  children,
  iconType,
  button,
  width = 'w-[800px]',
}: BannerProps) {
  const padding = useMemo(() => {
    if (button) return 'pt-2 pb-4 px-4';

    return 'p-4';
  }, [button]);

  const style = useMemo(() => styles[type], [type]);

  return (
    <div className={`${padding} flex gap-2 ${style} ${width} rounded-2`}>
      <Icon type={iconType || defaultIcons[type]} stroke={'stroke-black'} size={'size-5'} />
      <div className='grid gap-1 text-sm text-gray-700'>
        <p className='text-sm font-semibold text-black'>{title}</p>
        {children}
      </div>
    </div>
  );
}
